import { render, staticRenderFns } from "./MultiLevelChoices.vue?vue&type=template&id=0993d79c&scoped=true"
import script from "./MultiLevelChoices.vue?vue&type=script&lang=js"
export * from "./MultiLevelChoices.vue?vue&type=script&lang=js"
import style0 from "./MultiLevelChoices.vue?vue&type=style&index=0&id=0993d79c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0993d79c",
  null
  
)

export default component.exports